import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EmployeeService } from '../employee.service';
import { RBACService } from '../../shared/rbac.service';
import { UtilsService } from '../../shared/utils.service';

@Component({
  selector: 'app-employees-sites-worked-on',
  templateUrl: './employees-sites-worked-on.component.html',
  styleUrls: ['./employees-sites-worked-on.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EmployeesSitesWorkedOnComponent implements OnInit {
  // RBAC permission flags: resolved once in ngOnInit().
  canView: boolean = false;
  canEdit: boolean = false;
  canDelete: boolean = false;

  constructor(
    public employeeService: EmployeeService,
    public rbac: RBACService,
    public utils: UtilsService
  ) {}

  ngOnInit() {
    // Resolve RBAC permission flags.
    this.canView = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_EMPLOYEES_SITE_ASSOCIATIONS,
          RBACService.RBAC_A.A_VIEW
        )
      ],
      true
    );
    this.canEdit = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_EMPLOYEES_SITE_ASSOCIATIONS,
          RBACService.RBAC_A.A_EDIT
        )
      ],
      true
    );
    this.canDelete = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_EMPLOYEES_SITE_ASSOCIATIONS,
          RBACService.RBAC_A.A_DELETE
        )
      ],
      true
    );

    // Redirect if user has no permissions at all.
    if (!this.canView && !this.canEdit && !this.canDelete) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to access sites worked on.'
      );
      this.utils.redirectByLastSegment('details');
      return;
    }
  }

  protected readonly RBACService = RBACService;
}
